module.exports = __webpack_public_path__ + "img/logo-branca.d944b6a2.png";